import { useContext } from 'react';
import { StoreContext } from './StoreContext';
/**
 * Get the Store stored in the StoreContext
 */
export var useStoreContext = function () { return useContext(StoreContext); };
//# sourceMappingURL=useStoreContext.js.map